(() => {
  const selector='.story-button,.ref-button,.c-button,.ivori-checkout-submit,.cart__checkout-button,.product-form__submit,.shopify-payment-button__button,.ivori-upgrade-button,[data-story-cart-extra-add],button[name="add"],button[name="checkout"],input[type="submit"][name="add"],input[type="submit"][name="checkout"],shopify-accelerated-checkout,shopify-accelerated-checkout-cart';
  let pressed=null;
  const clear=()=>{pressed?.element.removeAttribute('data-ivori-pressed');pressed=null;};
  const control=event=>{
    for(const node of event.composedPath()){
      if(!(node instanceof Element))continue;
      const element=node.closest(selector);
      if(element)return element;
    }
    return null;
  };
  const start=(event,input)=>{
    const element=control(event);
    clear();
    if(!element || element.disabled || element.matches('[disabled],[aria-disabled="true"]') || element.closest('[inert]'))return;
    pressed={element,input};element.setAttribute('data-ivori-pressed','');
  };
  const passive={capture:true,passive:true};
  document.addEventListener('pointerdown',event=>{if(event.button===0 && event.isPrimary)start(event,'pointer');},passive);
  document.addEventListener('pointerup',clear,passive);
  document.addEventListener('pointercancel',clear,passive);
  document.addEventListener('pointermove',event=>{
    if(pressed?.input!=='pointer')return;
    const box=pressed.element.getBoundingClientRect();
    if(event.clientX<box.left || event.clientX>box.right || event.clientY<box.top || event.clientY>box.bottom)clear();
  },passive);
  document.addEventListener('pointerout',event=>{
    if(pressed?.input==='pointer' && (!event.relatedTarget || !pressed.element.contains(event.relatedTarget)))clear();
  },passive);
  document.addEventListener('keydown',event=>{
    if(event.key==='Escape')clear();
    else if((event.key===' ' || event.key==='Enter') && !event.repeat)start(event,'keyboard');
  },true);
  document.addEventListener('keyup',event=>{if(event.key===' ' || event.key==='Enter')clear();},true);
  document.addEventListener('close',clear,true);
  document.addEventListener('visibilitychange',()=>{if(document.hidden)clear();});
  window.addEventListener('blur',clear);
  window.addEventListener('pagehide',clear);
  window.addEventListener('pageshow',clear);
})();
